import { Route, Switch } from "react-router-dom";
import {
  routeHelpersWorkLogEdit,
  routeHelpersWorkLogLegacyDetails,
  routeHelpersWorkLogsPayee,
  routeHelpersWorkLogsPayeeApproved,
  routeHelpersWorkLogPayeeDetails,
  routeHelpersWorkLogsPayeeInProgress,
  routeHelpersWorkLogsPayeeRejected,
  routeHelpersWorkLogsPayeeSubmitted,
  routeHelpersWorkLogsPayer,
  routeHelpersWorkLogsPayerApproved,
  routeHelpersWorkLogsPayerDashboard,
  routeHelpersWorkLogPayerDetails,
  routeHelpersWorkLogsPayerRejected,
  routeHelpersWorkLogsPayerInProgress,
  routeHelpersWorkLogsPayerToApprove
} from "./paths";
import { RouteEdit } from "./routes/RouteEdit";
import { RoutePayeeLogs } from "./routes/RoutePayeeLogs";
import { RoutePayeeWorkLogDetails } from "./routes/RoutePayeeWorkLogDetails";
import { RoutePayerLogs } from "./routes/RoutePayerLogs";
import { RoutePayerWorkLogDetails } from "./routes/RoutePayerWorkLogDetails";
import { RouteWorkLogRedirect } from "./routes/RouteWorkLogRedirect";

export const WorkLogs = () => {
  return (
    <Switch>
      <Route path={routeHelpersWorkLogEdit.path} component={RouteEdit} />

      <Route
        exact
        path={[
          routeHelpersWorkLogsPayeeInProgress.path,
          routeHelpersWorkLogsPayeeSubmitted.path,
          routeHelpersWorkLogsPayeeApproved.path,
          routeHelpersWorkLogsPayeeRejected.path,
          routeHelpersWorkLogsPayee.path
        ]}
        component={RoutePayeeLogs}
      />

      <Route
        path={routeHelpersWorkLogPayeeDetails.path}
        component={RoutePayeeWorkLogDetails}
      />

      <Route
        exact
        path={[
          routeHelpersWorkLogsPayerDashboard.path,
          routeHelpersWorkLogsPayerToApprove.path,
          routeHelpersWorkLogsPayerApproved.path,
          routeHelpersWorkLogsPayerRejected.path,
          routeHelpersWorkLogsPayerInProgress.path,
          routeHelpersWorkLogsPayer.path
        ]}
        component={RoutePayerLogs}
      />

      <Route
        path={routeHelpersWorkLogPayerDetails.path}
        component={RoutePayerWorkLogDetails}
      />

      <Route
        path={routeHelpersWorkLogLegacyDetails.path}
        component={RouteWorkLogRedirect}
      />
    </Switch>
  );
};
